import { ColumnsType } from 'antd/es/table'
import Order from '../../../types/api/order'
import renderDate from '../../../helpers/tables/render-date'
import renderDatetime from '../../../helpers/tables/render-datetime'
import { resolveOrderItemRow } from '../product-type-resolvers'
import { orderStatusLabels, paymentTermsLabels } from './status-labels'

function formatOrderItemNames(order: Order): string {
    return (order.order_items ?? [])
        .map(item => resolveOrderItemRow(item).name?.trim())
        .filter(Boolean)
        .join(', ')
}

export const columns: ColumnsType<Order> = [
    {
        title: 'Номер заказа',
        dataIndex: 'id',
        width: 80,
    },
    {
        title: 'Клиент',
        dataIndex: ['client', 'name'],
        ellipsis: true,
    },
    {
        title: 'Создан',
        key: 'userAuditCreatedAt',
        width: 130,
        render: (_, record) => (record.createdAt ? renderDatetime(record.createdAt) : undefined),
    },
    {
        title: 'Позиции',
        key: 'orderItems',
        ellipsis: true,
        render: (_, record) => formatOrderItemNames(record) || undefined,
    },
    {
        title: 'Статус',
        dataIndex: 'orderStatus',
        width: 170,
        render: (status: Order['orderStatus']) =>
            status ? (orderStatusLabels[status] ?? status) : undefined,
    },
    {
        title: 'Срок',
        dataIndex: 'dueDate',
        width: 110,
        render: (v: string | undefined) => (v ? renderDate(v) : undefined),
    },
    {
        title: 'Оплата',
        dataIndex: 'paymentTerms',
        width: 120,
        render: (terms: Order['paymentTerms']) =>
            terms ? (paymentTermsLabels[terms] ?? terms) : undefined,
    },
    {
        title: 'Подтверждён',
        dataIndex: 'confirmedAt',
        width: 110,
        render: (v: string | undefined) => (v ? renderDate(v) : undefined),
    },
]
